export default "__VITE_ASSET__B_GV2Ctc__"